module.exports = __webpack_public_path__ + "media/icons/clipboard-9896794e876642321ef992e6bb2a2d31.svg";